import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import bankService from "../../services/BankService";


export const getBankList = createAsyncThunk(
    "bank/getBankList",
    async (_,{ rejectWithValue }) => {
        try {
            const response = await bankService.GetBankList();
            return response.data?.ResultSet || [];
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.Message || 
                error.message || 
                "Failed to get bank list"
            );
        }
    }
)

export const addBank = createAsyncThunk(
    "bank/addBank",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await bankService.AddBank(payload);
            return response.data?.ResultSet || [];
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.Message || 
                error.message || 
                "Failed to add bank"
            );
        }
    }
)

export const updateBank = createAsyncThunk(
    "bank/updateBank",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await bankService.UpdateBank(payload);
            return response.data?.ResultSet || [];
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.Message || 
                error.message || 
                "Failed to update bank"
            );
        }
    }
)

const initialState = {
  banks: [],

  loading: false,

  saving: false,

  error: null,
  success: false,
};

const bankSlice = createSlice({
    name: "bank",
    initialState,
    reducers: {
        clearBankError: (state) => {
            state.error = null;
        },

        clearBankSuccess: (state) => {
            state.success = false;
        },

        clearBanks: (state) => {
            state.banks = [];
        }
    },

    extraReducers: (builder) => {
        builder

        // Get designation list
        .addCase(
            getBankList.pending,
            (state) => {
                state.loading = true;
                state.error = null;
            }
        )
        .addCase(
            getBankList.fulfilled,
            (state, action) => {
                state.loading = false;
                state.banks = action.payload;
            }
        )
        .addCase(
            getBankList.rejected,
            (state, action) => {
                state.loading = false;
                state.error = action.payload || "Failed to load banks";
            }
        )

        // Add Designation
        .addCase(addBank.pending, (state) => {
            state.saving = true;
            state.error = null;
            state.success = false;
        })
        .addCase(addBank.fulfilled, (state) => {
            state.saving = false;
            state.success = true;
        })
        .addCase(addBank.rejected, (state, action) => {
            state.saving = false;
            state.error = action.payload || "Failed to add bank"
        })

        // Update Designation
        .addCase(updateBank.pending, (state) => {
            state.saving = true;
            state.error = null;
            state.success = false;
        })
        .addCase(updateBank.fulfilled, (state) => {
            state.saving = false;
            state.success = true;
        })
        .addCase(updateBank.rejected, (state, action) => {
            state.saving = false;
            state.error = action.payload || "Failed to update bank"
        })
    }
})

export const {
    clearBankError,
    clearBankSuccess,
    clearBanks
} = bankSlice.actions;

export default bankSlice.reducer;